import { CommonModule } from '@angular/common';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentTagToTextIconPipe } from '@app/features/documents/document-tag-to-text-icon-pipe';
import { CdTDocument } from '@app/features/documents/document.model';
import { LabelValue } from '@app/shared/forms/label-value/label-value';
import { TextIcon } from '@app/shared/icons/text-icon/text-icon';
import { DocumentsFormValue } from '../../embauche-tabs-form/documents-form/documents-form';

@Component({
  selector: 'app-documents-view',
  imports: [
    CommonModule,
    TextIcon,
    MatTooltipModule,
    DocumentTagToTextIconPipe,
    MatButtonModule,
    LabelValue,
  ],
  templateUrl: './documents-view.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./documents-view.scss'],
})
export class DocumentsView {
  documents = input.required<DocumentsFormValue>();
  selected = output<CdTDocument>();

  onClick(document: CdTDocument) {
    this.selected.emit(document);
  }
}
